import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';


@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    imports: []
})
export class LogoutComponent implements OnInit {

  isLoading = true;

  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit(): void {

    this.auth.logout().subscribe({
        next: () => {          
          this.router.navigate(['/login']); 
        }
    });

  }
}
